/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-21 13:53:07
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { ButtonGroup, Button, InlineError } from '@shopify/polaris';
import { Field } from 'redux-form';
import { PlusMinor, MinusMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { numberWithCommas, normalizeNumberWithComma } from 'src/helpers/form-validation-helper';
import { RenderTextField } from 'src/components/views/common/forms/render-textfield';

type Props = {
  fields: any[],
  percentSaleList: Object,
  meta: Object,
  updatePercentSaleListItem: () => void
};

type ComposedProps = Props & WithI18nProps;

class ValuesList extends Component<ComposedProps> {
  render() {
    const { fields, meta, percentSaleList, i18n } = this.props;
    return (
      <div className="BC-List__Values">
        <div>
          <div className="priceItem">
            <div className="fromPrice">
              <span>
                {i18n.translate(
                  'AdminHTML.FilterTree.Item.optionModal_GeneralTab_ValuesList_Above'
                )}{' '}
              </span>
              <span>{numberWithCommas(percentSaleList[0].to)}</span>
            </div>
          </div>
          {fields.map((item, index) => {
            const priceIndex = percentSaleList[index];
            const from = priceIndex ? priceIndex.from : 0;
            return (
              <div className="priceItem" key={index}>
                <div className="fromPrice">
                  <span>
                    {i18n.translate(
                      'AdminHTML.FilterTree.Item.optionModal_GeneralTab_ValuesList_From'
                    )}{' '}
                  </span>
                  <span>{from ? numberWithCommas(from) : 0}</span>
                </div>
                <div className="toPrice">
                  <span>
                    {i18n.translate(
                      'AdminHTML.FilterTree.Item.optionModal_GeneralTab_ValuesList_to'
                    )}
                  </span>

                  <Field
                    name={`${item}.to`}
                    component={RenderTextField}
                    onChange={(e, value) => this.onChangeTo(value, index)}
                    onBlur={(e, value) => this.onBlurTo(e, value, index)}
                    format={value => numberWithCommas(value)}
                    normalize={(value, prevValue) => normalizeNumberWithComma(value, prevValue)}
                  />
                </div>
                <div className="button">
                  <ButtonGroup>
                    <Button outline onClick={() => this.addValue(index)} icon={PlusMinor} />
                    {index < percentSaleList.length - 1 ? (
                      <Button outline onClick={() => this.deleteValue(index)} icon={MinusMinor} />
                    ) : (
                      ''
                    )}
                  </ButtonGroup>
                </div>
              </div>
            );
          })}
        </div>
        {meta.error ? <InlineError message={meta.error} /> : ''}
      </div>
    );
  }

  // Handle change input
  onChangeTo = (value, key) => {
    const newValue = value ? parseInt(value) : 0;
    const { percentSaleList, updatePercentSaleListItem } = this.props;
    let i = key;
    while (i > 0) {
      const from = parseInt(percentSaleList[i - 1].from);
      if (newValue < from) {
        return;
      }
      let to = parseInt(percentSaleList[i - 1].to);
      let flag = false;
      if (to < newValue) {
        to = newValue;
      } else {
        flag = true;
      }
      if (newValue <= 100) {
        updatePercentSaleListItem(i - 1, { from: newValue, to });
      } else {
        flag = true;
      }
      i--;
      if (flag) {
        break;
      }
    }
  };

  // Handle blur input
  onBlurTo = (event, value, key) => {
    const formatedValue = value ? parseInt(value) : 0;
    let newValue = formatedValue;
    const { percentSaleList, updatePercentSaleListItem } = this.props;
    const from = percentSaleList[key].from ? parseInt(percentSaleList[key].from) : 0;
    if (key > 0) {
      const previousFrom = parseInt(percentSaleList[key - 1].from);
      if (newValue < previousFrom || newValue > 100) {
        newValue = previousFrom;
      }
    } else {
      if (!from && newValue === 0) {
        newValue = 1;
      } else if (newValue < from) {
        newValue = from;
      } else if (newValue > 100) {
        newValue = 100;
      }
    }
    if (newValue !== formatedValue) {
      updatePercentSaleListItem(key, { from: from, to: newValue });
      event.preventDefault();
    }
  };

  // Handle remove button
  deleteValue = key => {
    const { fields, percentSaleList, updatePercentSaleListItem } = this.props;

    if (key > 0) {
      const { to } = percentSaleList[key - 1];
      const from = percentSaleList[key + 1].to;

      updatePercentSaleListItem(key - 1, { from, to });
    }

    fields.remove(key);
  };

  // Handle add button
  addValue = key => {
    const { fields, percentSaleList } = this.props;
    let { from } = percentSaleList[key];
    from = from ? from : 0;
    fields.insert(key + 1, { from, to: from });
  };
}

export default withI18n()(ValuesList);
